var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJantungIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09998 9.33876C3.09998 6.14229 5.53502 3.5 8.60398 3.5C10.1883 3.5 11.6048 4.20987 12.6002 5.33332C13.5974 4.20958 15.0199 3.5 16.596 3.5C19.6649 3.5 22.1 6.14229 22.1 9.33876C22.1 10.051 22.005 10.7759 21.8271 11.5H18.8071L17.6988 10.3917C17.3368 10.0297 16.7266 10.1288 16.4976 10.5866L15.463 12.6559L14.6622 11.8551C14.3345 11.5274 13.791 11.5724 13.5216 11.9495L11.8378 14.3069L10.7334 9.52135C10.579 8.85198 9.68064 8.72525 9.34702 9.32576L7.53735 12.5832L6.67293 11.4306C6.39908 11.0655 5.86533 11.0275 5.5426 11.3503L4.89287 12H3.42826C3.21429 11.1458 3.09998 10.2564 3.09998 9.33876Z",
    fill: "#358888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7292 13C5.08397 16.845 8.47597 19.8668 12.4227 21.363C12.5369 21.4063 12.663 21.4063 12.7772 21.363C15.3729 20.379 17.6953 18.5473 19.3699 16.3901C20.3099 15.1793 21.056 13.8524 21.5291 12.5H18.7035C18.5046 12.5 18.3139 12.421 18.1732 12.2803L17.237 11.3441L16.2023 13.4134C15.9734 13.8712 15.3631 13.9703 15.0012 13.6083L14.1638 12.7709L12.3292 15.3394C11.9536 15.8651 11.1334 15.7016 10.9881 15.0721L9.90529 10.38L8.22428 13.4058C7.96039 13.8808 7.29469 13.9263 6.96866 13.4916L6.04588 12.2612L5.52675 12.7803C5.3861 12.921 5.19533 13 4.99642 13H3.7292Z",
    fill: "#358888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJantungIcon);
export default __webpack_public_path__ + "static/media/jantung_icon.f00f7f8765d037225c3c04ec8f29fb7b.svg";
export { ForwardRef as ReactComponent };